import {
  SET_LANDING_SEARCH_STRING,
  CLEAR_LANDING_SEARCH_STRING,
  GET_APP_CONFIG_SUCCESS,
  GET_APP_CONFIG_FAILURE,
  GET_APP_CONFIG_REQUEST,
  GET_ETH_VS_USD_CONVERTER_REQUEST,
  GET_ETH_VS_USD_CONVERTER_SUCCESS,
  GET_ETH_VS_USD_CONVERTER_FAILURE,
} from '../actionTypes/generalActionTypes';
import { getAppConfig, getCoinConverterRequest } from '../../services/generalService';
import { HPOOL_DEFAULT_TOKEN } from '../../constants/createHPool';
import { getCointConvertUrl } from '../../services/assetsService';

/**
 * Sets the landing select search value
 *
 * @param option {Object}
 * @param payload {String}
 * @returns {function(*): void}
 */
export const setLandingSearchString = (option, payload) => (dispatch) =>
  dispatch({ type: SET_LANDING_SEARCH_STRING, payload });

/**
 * Clears the landing select searchValue
 * @returns {function(*): *}
 */
export const clearLandingSearchString = () => (dispatch) => dispatch({ type: CLEAR_LANDING_SEARCH_STRING });

export const getAppConfigAction = (isVpool) => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_APP_CONFIG_REQUEST });
    const { createHPool } = getState();
    const poolAssets = createHPool?.hpool?.assets; // Don't override addedTokens in case of pool exists
    // if (poolAssets?.length) return;
    const payload = await getAppConfig(isVpool);
    // payload.tokens = { ...payload.tokens, ...HPOOL_DEFAULT_TOKEN };
    dispatch({ type: GET_APP_CONFIG_SUCCESS, payload });
    return payload;
  } catch (payload) {
    dispatch({ type: GET_APP_CONFIG_FAILURE, payload });
  }
};
export const getCoinConverterAction =
  (_name = 'ethUsd', base, vs) =>
  async (dispatch, getState) => {
    dispatch({ type: GET_ETH_VS_USD_CONVERTER_REQUEST }); // eslint-disable-line object-curly-newline

    try {
      const { payload, name } = await getCoinConverterRequest(base, vs, _name);
      dispatch({ type: GET_ETH_VS_USD_CONVERTER_SUCCESS, payload, name }); // eslint-disable-line object-curly-newline
    } catch (err) {
      dispatch({ type: GET_ETH_VS_USD_CONVERTER_FAILURE, payload: err.message }); // eslint-disable-line object-curly-newline

      return false;
    }
  };
